const translation = {
  errorBoundary: {
    title: 'Etwas ist schiefgelaufen',
    description: 'Diese Seite konnte nicht angezeigt werden. Ihre Daten wurden nicht geändert. Versuchen Sie es erneut oder laden Sie die Seite neu.',
    offlineTitle: 'Wir erreichen die Plattform nicht',
    offlineDescription: 'Die Verbindung zur Plattform ist fehlgeschlagen. Prüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.',
    retry: 'Erneut versuchen',
    reload: 'Seite neu laden',
  },
  notifications: {
    empty: 'Keine neuen Benachrichtigungen',
    clearAll: 'Alle löschen',
    clearAllConfirm: 'Alle Benachrichtigungen löschen? Dies kann nicht rückgängig gemacht werden.',
    clearAllFailed: 'Benachrichtigungen konnten nicht gelöscht werden',
    markReadFailed: 'Benachrichtigung konnte nicht als gelesen markiert werden',
    delete: 'Benachrichtigung löschen',
    deleteFailed: 'Benachrichtigung konnte nicht gelöscht werden',
    reminderTitle: 'Messung bald fällig',
    reminderBody: 'Es ist fast Zeit, {{measurement}} für {{programme}} zu erfassen.',
    cleared: 'Benachrichtigungen gelöscht',
    deleted: 'Benachrichtigung gelöscht',
  },
  dataGrid: {
    noResultsFound: 'Keine Ergebnisse gefunden',
    selectAll: 'Alle auswählen',
    selectRow: '{{name}} auswählen',
    rowLabel: 'Zeile {{id}}',
    ascending: 'Aufsteigend',
    descending: 'Absteigend',
    sortByColumn: 'Nach {{column}} sortieren ({{direction}})',
  },
  manageUsers: {
    title: 'Mitglieder der Organisation',
    subtitle: 'Die Menschen in Ihrer Organisation und welche Rolle sie hier haben.',
    nameColumn: 'Name',
    emailColumn: 'E-Mail',
    rolesColumn: 'Rollen',
    rolesPlaceholder: 'Rolle hinzufügen',
    rolesSaved: 'Rollen aktualisiert',
    rolesFailed: 'Die Rollen konnten nicht aktualisiert werden',
    filterLabel: 'Rolle',
    filterAll: 'Alle Rollen',
    filterNone: 'Ohne Rolle',
    noTenantNotice: 'Mitglieder werden pro Organisation gelistet, und dieses Konto gehört zu keiner.',
    noTenantTitle: 'Noch keine Organisation',
  },
  navGroups: {
    general: 'Allgemein',
    programmes: 'Programme',
    mySettings: 'Einstellungen',
  },
  navigation: {
    ownEnvironment: 'Meine eigene Umgebung',
    platformEnvironment: 'Plattformverwaltung',
    switchEnvironment: 'Umgebung wechseln',
    manageUsers: 'Mitglieder der Organisation',
    dashboard: 'Mein Dashboard',
    foodTracking: 'Nahrungsverfolgung',
    activity: 'Aktivität',
    sleep: 'Schlaf',
    weightBmi: 'Gewicht/BMI',
    wellnessValues: 'Wellness-Werte',
    progress: 'Fortschritt',
    insights: 'Einblicke',
    myCommunity: 'Meine Gemeinschaft',
    coaches: 'Coaches',
    coaching: 'Coaching',
    myProgrammes: 'Meine Programme',
    programs: 'Programme',
    researchData: 'Forschungsdaten',
    education: 'Bildung',
    analytics: 'Analytik',
    billing: 'Abrechnung',
    shareData: 'Daten Teilen',
    settings: 'Sprache & Region',
    profile: 'Mein Profil',
    logout: 'Abmelden',
    masterData: 'Stammdaten',
    metabolicMeasurements: 'Meine Messungen',
    weeklyData: 'Wöchentliche Daten',
    tenantSettings: 'Tenant-Einstellungen',
    dataManagement: 'Dateneinstellungen',
    manageProgrammes: 'Programmeinstellungen',
    manageProgrammeMeasurements: 'Programmdaten',
    manageRoles: 'Rollen',
    dataPermissions: 'Datenberechtigungen',
    dataProviders: 'Datenquellen',
    adminDataProviders: 'Alle FHIR-Server',
    uploadPDF: 'PDF Hochladen',
    savedDocuments: 'Meine Dokumente',
    pinSidebar: 'Seitenleiste anheften',
    unpinSidebar: 'Seitenleiste lösen',
  },
  devLogin: {
    subtitle: 'Lokale Entwicklung — Authentifizierung umgangen',
    roles: {
      globalAdmin: 'Globaler Admin',
      tenantAdmin: 'Mandanten-Admin',
      coach: 'Coach',
      member: 'Mitglied',
      remoteMember: 'Remote-Mitglied',
    },
  },
  brand: {
    loading: 'Wird geladen',
  },
  auth: {
    platformName: 'My Lifestyle Platform',
    poweredBy: 'betrieben von Stichting Je Leefstijl Als Medicijn',
    platformLogin: 'Plattform-Anmeldung',
    password: 'Passwort',
    signIn: 'Anmelden',
    signUp: 'Registrieren',
    forgotPassword: 'Passwort vergessen?',
    requestAccess: 'Zugang beantragen',
    demoMode: 'Demo-Modus - Verwenden Sie beliebige Anmeldedaten',
    demoDescription: 'Zugang zu Ihrem vollständigen Lifestyle-Wellness-Dashboard',
    loginSuccess: 'Anmeldung erfolgreich! Weiterleitung...',
    sessionExpired: {
      title: 'Ihre Sitzung ist abgelaufen',
      message: 'Zum Schutz Ihrer Daten wurden Sie automatisch abgemeldet. Melden Sie sich erneut an, um fortzufahren.',
      signIn: 'Erneut anmelden',
      dismiss: 'Später',
    },
  },
  dashboard: {
    refreshData: 'Daten aktualisieren',
    lastSynced: 'Zuletzt synchronisiert {{time}}',
    justSynced: 'Gerade synchronisiert',
    signInRequired: 'Sie müssen angemeldet sein, um das Dashboard anzuzeigen.',
    unableToLoad: 'Dashboard-Daten können nicht geladen werden.',
    activeProgrammes: 'Aktive Programme',
    programmes: 'Programme',
    trackedMeasurements: 'Verfolgte Messungen',
    targetsConfigured: 'Konfigurierte Ziele',
    dateAxisLabel: 'Datum',
    measurementTrends: 'Messtrends',
    measurementTrendsSubtitle: 'Gestapelte Ansicht, um alle Messungen gemeinsam zu erkunden.',
    timeRange: 'Zeitbereich:',
    oneYear: '1 Jahr',
    days: '{{count}}T',
    noMeasurementData: 'Noch keine Messdaten',
    noMeasurementDataSubtitle: 'Wenn neue Datenpunkte eintreffen, wird die Zeitachse automatisch aktualisiert.',
    programmeTargets: 'Programmziele',
    programmeTargetsSubtitle: 'Ziele werden von Ihrem Programmadministrator festgelegt und hier als Referenz angezeigt.',
    noProgrammeMeasurements: 'Noch keine Programmmessungen verfügbar.',
    latestValue: 'Letzter Wert',
    targetRange: 'Zielbereich',
    noMeasurementRecorded: 'Noch keine Messung aufgezeichnet',
    onTarget: 'Im Ziel',
    needsAttention: 'Benötigt Aufmerksamkeit',
    noTargetSet: 'Kein Ziel gesetzt',
    min: 'Min: {{value}} {{unit}}',
    max: 'Max: {{value}} {{unit}}',
    rangeTarget: '{{min}} - {{max}} {{unit}}',
    scopeFrom: 'Messwerte anzeigen ab',
    scopeTo: 'Messwerte anzeigen bis einschließlich',
    saved: 'Ihre Anordnung ist gespeichert.',
    settingsSaved: '{{name}} ist gespeichert.',
    deleted: '{{name}} wurde gelöscht.',
  },
  profile: {
    welcomeNewUser: 'Willkommen! Bitte vervollständigen Sie Ihr Profil',
    newUserMessage: 'Helfen Sie uns, Ihre Erfahrung zu personalisieren, indem Sie Ihre Daten unten ausfüllen.',
    continueToDashboard: 'Weiter zum Dashboard',
    myProfile: 'Mein Profil',
    reviewDetails: 'Überprüfen und aktualisieren Sie Ihre persönlichen Daten',
    completeProfile: 'Vervollständigen Sie Ihr Profil',
    keepUpdated: 'Halten Sie Ihre Informationen aktuell für bessere personalisierte Einblicke',
    accountInformation: 'Kontoinformationen',
    referenceCode: 'Referenzcode',
    anonymousSharingId: 'Ihre anonyme Freigabe-ID',
    activeSince: 'Aktiv seit',
    personalDetails: 'Persönliche Daten',
    firstName: 'Vorname',
    lastName: 'Nachname',
    nickname: 'Spitzname',
    nicknamePlaceholder: 'Wie möchten Sie angesprochen werden?',
    birthDate: 'Geburtsdatum',
    gender: 'Geschlecht',
    genderMale: 'Männlich',
    genderFemale: 'Weiblich',
    genderPrefernottosay: 'Keine Angabe',
    emailAddress: 'E-Mail-Adresse',
    emailPlaceholder: 'ihre.email@beispiel.de',
    emailHelper: 'E-Mail-Adresse für Updates und Benachrichtigungen',
    aboutMe: 'Über Mich',
    headline: 'Überschrift',
    headlinePlaceholder: 'Ein kurzer Slogan über Sie',
    bio: 'Biografie',
    bioPlaceholder: 'Erzählen Sie uns etwas über sich',
    motivation: 'Motivation',
    motivationPlaceholder: 'Was motiviert Sie, diese Plattform zu nutzen?',
    privacyDataSharing: 'Datenschutz & Datenweitergabe',
    sharingPreference: 'Freigabepräferenz',
    sharingHelper: 'Wählen Sie, wie Sie Ihre Daten auf dieser Plattform teilen möchten',
    shareAnonymously: 'Meine Daten anonym teilen',
    shareWithName: 'Meine Daten mit meinem Namen teilen',
    doNotShare: 'Meine Daten nicht teilen',
    notificationPreferences: 'Benachrichtigungseinstellungen',
    pushNotifications: 'Push-Benachrichtigungen',
    pushNotificationsDesc: 'Push-Benachrichtigungen auf Ihrem Gerät erhalten',
    emailNotifications: 'E-Mail-Benachrichtigungen',
    emailNotificationsDesc: 'Benachrichtigungen per E-Mail erhalten',
    inAppNotifications: 'In-App-Benachrichtigungen',
    inAppNotificationsDesc: 'Benachrichtigungen innerhalb der Anwendung erhalten',
    programmeNotifications: 'Programmbenachrichtigungen',
    programmeNotificationsHelper: 'Wähle je Programm, wie viele Minuten vor einer geplanten Messung du erinnert werden möchtest. Schalte Benachrichtigungen für ein Programm aus, um dessen Erinnerungen vollständig zu stoppen.',
    reminderTime: 'Erinnerungszeit',
    reminderTimeCustomLabel: 'Minuten (1-180)',
    reminderNoScheduledMeasurements: 'Dieses Programm hat noch keine geplanten Messungen.',
    notificationsLabel: 'Benachrichtigungen',
    reminderLoadFailed: 'Erinnerungseinstellungen konnten nicht geladen werden',
    saving: 'Speichern...',
    saveProfile: 'Profil Speichern',
    saveSuccess: 'Profil erfolgreich gespeichert',
    errorLoading: 'Profil konnte nicht geladen werden',
    errorSaving: 'Profil konnte nicht gespeichert werden',
  },
  uploadPDF: {
    title: 'Dokument hochladen',
    description: 'Hier können Sie Ihre PDF-Dateien hochladen.',
    documentType: 'Dokumenttyp',
    selectDocumentType: 'Dokumenttyp auswählen',
    labTest: 'Labortest',
    insuranceDocument: 'Versicherungsdokument',
    idCard: 'Ausweis',
    enabledAIExtraction: 'Aktiviert: Wir extrahieren Beobachtungen nach dem Upload.',
    disabledAIExtraction: 'Deaktiviert: Wir speichern nur das Dokument.',
    descriptionTitle: 'Beschreibung',
    descriptionLabel: 'Beschreibung',
    descriptionPlaceholder: 'z. B. Bluttest vom Arztbesuch (24/01/2026)',
    filenameTitle: 'Dateiname',
    filenameLabel: 'Dateiname',
    filenamePlaceholder: 'Dateinamen eingeben',
    filenameRequired: 'Bitte geben Sie einen Dateinamen ein.',
    aiExtractionTitle: 'KI-Extraktion',
    aiExtractionSelectTypeHelper: 'Select a document type to see AI extraction options.',
    dropFilesPrompt: 'Dateien hier ablegen oder von Ihrem Gerät auswählen',
    chooseFiles: 'Datei(en) auswählen',
    deleteDocument: 'Auswahl löschen',
    filesSelected: 'Datei ausgewählt',
    uploadButton: 'Hochladen',
    documentSuccessfullyUploaded: 'Dokument erfolgreich hochgeladen.',
    aiExtractionNotAvailable: 'KI-Extraktion ist fuer diesen Dokumenttyp nicht verfuegbar',
  },
  savedDocuments: {
    fileName: 'Dateiname',
    fileType: 'Dateityp',
    uploadedBy: 'Hochgeladen von',
    description: 'Beschreibung',
    uploadDate: 'Hochladedatum',
    status: 'Status',
    inProgress: 'In Bearbeitung',
    readyForReview: 'Bereit zur Überprüfung',
    committed: 'Festgeschrieben',
    inReview: 'In Überprüfung',
    uploaded: 'Hochgeladen',
    failed: 'Fehlgeschlagen',
    unknownStatus: 'Fehlgeschlagen',
    noStatus: 'Kein Status',
    noDocuments: 'Keine Dokumente gefunden',
    yourDocuments: 'Ihre Dokumente',
    viewPreviouslyUploaded: 'Zuvor hochgeladene Dokumente anzeigen',
    documents: 'Dokumente',
    filter: 'Filtern',
    allTypes: 'Alle',
    preview: 'Vorschau',
    uploadNewDocument: 'Ein neues Dokument hochladen',
    review: 'Überprüfen',
    delete: 'Löschen',
    updateDocument: 'Dokument aktualisieren',
    update: 'Aktualisieren',
    cancel: 'Abbrechen',
    save: 'Speichern',
    documentSuccessfullyDeleted: 'Dokument erfolgreich gelöscht',
    deleteError: 'Fehler beim Löschen des Dokuments',
    deleteErrorPartial_one: '{{count}} Dokument konnte nicht gelöscht werden',
    deleteErrorPartial_other: '{{count}} Dokumente konnten nicht gelöscht werden',
    downloadError: 'Dokument konnte nicht heruntergeladen werden',
    deleteConfirm: 'Möchten Sie wirklich {{count}} Dokument(e) löschen?',
    deleting: 'Wird gelöscht...',
    close: 'Schließen',
    download: 'Herunterladen',
    types: {
      bloodTestReport: 'Blutuntersuchungsbericht',
      stoolTestReport: 'Stuhluntersuchungsbericht',
      consultationNote: 'Beratungsnotiz',
    },
    updateSuccess: 'Dokument aktualisiert',
    updateError: 'Das Dokument konnte nicht aktualisiert werden',
  },
  documentExtractionReview: {
    aiChip: 'TRPI Powered by KI',
    title: 'Extraktionsprüfung',
    previewTitle: 'Dokumentvorschau',
    preview: {
      loadingDocument: 'Dokument wird geladen...',
      preparingPdf: 'PDF wird vorbereitet...',
      zoom: 'Zoom {{percent}}%',
      zoomControlsAria: 'Zoom-Steuerung',
      zoomOut: 'Verkleinern',
      fit: 'Anpassen',
      zoomIn: 'Vergrößern',
      fullscreen: 'Vollbild',
      exitFullscreen: 'Vollbild beenden',
      unavailable: 'Die In-App-Vorschau ist für diese Datei nicht verfügbar. Laden Sie diese Datei herunter, um sie anzuzeigen.',
      pageOf: 'Seite {{current}} von {{total}}',
      prevPageAria: 'Vorherige Seite',
      nextPageAria: 'Nächste Seite',
    },
    subtitle: 'Überprüfen Sie die extrahierten Werte, bevor Sie sie in Ihre Kernbeobachtungen übernehmen.',
    committedInfo: 'Dieses Dokument kann nicht weiter bearbeitet werden, Sie können die extrahierten Werte weiterhin einsehen.',
    commit: {
      action: 'In Kern übernehmen',
      committed: 'Übernommen',
      aria: 'Extrahierte Messwerte übernehmen',
      success: 'Dokument übernommen',
      error: 'Dokument konnte nicht übernommen werden',
    },
    tooltips: {
      download: 'Herunterladen',
      fullscreen: 'Vollbild',
      exitFullscreen: 'Vollbild beenden',
    },
    aria: {
      download: 'Dokument herunterladen',
      fullscreen: 'Vollbildmodus für rechten Bereich umschalten',
    },
    updatedAt: 'Aktualisiert am: {{date}}',
    failedMessage: 'Extraktion fehlgeschlagen. Sie können das Dokument weiterhin anzeigen. Bitte kontaktieren Sie den Support, wenn das Problem weiterhin besteht.',
    loadDataError: 'Fehler beim Laden der extrahierten Daten. Bitte versuchen Sie es erneut.',
    extractionInProgress: 'Die Extraktion ist im Gange.',
    notExtracted: 'Nicht extrahiert',
    timeline: {
      button: 'Zeitachse anzeigen',
      title: 'Extraktionszeitachse',
    },
    loading: 'Extraktion wird geladen...',
    providers: {
      organisation: 'Organisation',
      practitioner: 'Behandler',
      searchPlaceholder: 'Nach vorhandener {{type}} suchen',
      notInList: 'Nicht in der Liste',
    },
    sections: {
      measurements: {
        title: 'Extrahierte Messungen',
        columns: {
          measurementName: 'Extrahierte Messung',
          valueExtracted: 'Extrahierter Wert',
          unitExtracted: 'Einheit (extrahiert)',
          ucumCode: 'UCUM-Code',
          ucumName: 'UCUM-Name',
          loincCode: 'LOINC-Code',
          loincName: 'LOINC-Name',
          referenceRangeMin: 'Ref Min',
          referenceRangeMax: 'Ref Max',
        },
        actions: {
          resetColumns: 'Spaltensichtbarkeit zurücksetzen',
          edit: 'Messungen bearbeiten',
          save: 'Messungen speichern',
          cancel: 'Messungsänderungen abbrechen',
          deleteRow: 'Zeile löschen',
          deleteRowDisabled: 'Bearbeitungsmodus aktivieren, um Zeilen zu löschen',
          addRow: 'Zeile hinzufügen',
        },
        aria: {
          resetColumns: 'Spaltensichtbarkeit zurücksetzen',
          edit: 'Extrahierte Messungen bearbeiten',
          save: 'Extrahierte Messungen speichern',
          cancel: 'Änderungen an extrahierten Messungen abbrechen',
          deleteRow: 'Zeile {{id}} löschen',
        },
        toasts: {
          addSuccess: 'Messungszeile hinzugefügt',
          addError: 'Messungszeile konnte nicht hinzugefügt werden',
          deleteSuccess: 'Messung gelöscht',
          deleteError: 'Messung konnte nicht gelöscht werden',
        },
      },
      organisation: {
        title: 'Ausführende Organisation',
        status: {
          matchFound: 'Organisation gefunden',
          noMatch: 'Keine passende Organisation',
        },
        tooltips: {
          validation: 'Bitte die richtigen Werte ausfüllen',
          save: 'Organisationsdetails speichern',
          cancel: 'Organisationsänderungen abbrechen',
        },
        aria: {
          edit: 'Ausführende Organisation bearbeiten',
          save: 'Änderungen der ausführenden Organisation speichern',
          cancel: 'Extrahierte Organisationsänderungen abbrechen',
        },
        fields: {
          name: 'Name',
          address: 'Adresse',
          houseNumber: 'Hausnummer',
          city: 'Stadt',
          postalCode: 'Postleitzahl',
          countryCode: 'Ländercode',
          contactPerson: 'Kontaktperson',
          phoneNumber: 'Telefonnummer',
          emailAddress: 'E-Mail-Adresse',
        },
      },
      practitioner: {
        title: 'Anfordernder Behandler',
        status: {
          matchFound: 'Behandler gefunden',
          noMatch: 'Kein passender Behandler',
        },
        tooltips: {
          validation: 'Bitte die richtigen Werte ausfüllen',
          save: 'Behandlerdetails speichern',
          cancel: 'Behandleränderungen abbrechen',
        },
        aria: {
          edit: 'Anfordernden Behandler bearbeiten',
          save: 'Änderungen des anfordernden Behandlers speichern',
          cancel: 'Extrahierte Behandleränderungen abbrechen',
        },
        fields: {
          name: 'Name',
          role: 'Rolle',
          phoneNumber: 'Telefonnummer',
          emailAddress: 'E-Mail-Adresse',
        },
      },
    },
    sectionSaved: 'Ihre Änderungen sind gespeichert.',
    sectionSaveFailed: 'Ihre Änderungen konnten nicht gespeichert werden.',
  },
  content: {
    billing: {
      title: 'Abrechnung und Zahlungen',
      description: 'Verwalten Sie Abonnements, Zahlungen und Premium-Funktionen für erweiterte Funktionalität.',
      viewBilling: 'Abrechnung Anzeigen',
    },
  },
  masterData: {
    tabs: {
      measurements: 'Messungen',
      units: 'Einheiten',
    },
    measurementList: {
      subtitle: 'Jeder Code, den die Plattform kennt: die LOINC-Version und die eigenen Codes. Öffne einen, um seine Achsen und Einheiten zu sehen.',
    },
    measurementCodes: {
      list: {
        columns: {
          name: 'Name',
          code: 'Code',
          codeSystem: 'Codesystem',
          status: 'Status',
          inUse: 'In Gebrauch',
        },
        yes: 'Ja',
        no: 'Nein',
        views: {
          label: 'Anzeigen',
          all: 'Alle Codes',
          inUse: 'In Gebrauch',
        },
        systemFilter: 'Codesystem',
        systemAll: 'Alle Codesysteme',
      },
      general: {
        code: 'Code',
        codeSystem: 'Codesystem',
        name: 'Name',
        status: 'Status',
        release: 'Version',
        releaseValue: '{{version}}, geladen am {{date}}',
        releaseNone: 'Nicht zutreffend: Zu einem Plattform-Code gehört keine Version.',
        releaseUnknown: 'Für diesen Code nicht erfasst.',
        valueKind: 'Art des Werts',
        quantityKind: 'Art der Größe',
      },
      axes: {
        title: 'Was gemessen wird',
        component: 'Komponente',
        analyte: 'Analyt',
        property: 'Eigenschaft',
        time: 'Zeit',
        system: 'System',
        scale: 'Skala',
        method: 'Methode',
        noMethod: 'Keine',
        unknown: 'Die Plattform kennt die Achsen dieses Codes nicht. Er wird mit nichts gruppiert.',
      },
      groups: {
        title: 'Gruppiert mit',
        nothing: 'Auf dieser Ebene mit nichts gruppiert.',
      },
      levels: {
        THIS_CODE: 'Nur dieser Code',
        ANY_METHOD: 'Dasselbe, egal mit welcher Methode',
      },
      trace: {
        title: 'Einen Wert nachverfolgen',
        help: 'Gib die Nummer ein, die du für einen Wert bekommst. Du siehst, als was er erfasst wurde und woher er stammt.',
        number: 'Wertnummer',
        show: 'Herkunft anzeigen',
      },
      dialog: {
        addTitle: 'Plattform-Messung hinzufügen',
        editTitle: '{{name}} bearbeiten',
        name: 'Name',
        code: 'Code',
        codeHelp: 'Beginnt mit X, zum Beispiel X-HAPPY-1. Keine zwei Messungen teilen sich einen Code.',
        codeSystem: 'Codesystem',
        analyteHelp: 'Leer lassen, um die Komponente zu verwenden.',
        noPart: 'Kein Part passt. Tippe einen Namen, um einen hinzuzufügen.',
        partsFailed: 'Die Parts konnten nicht gelesen werden. Tippe erneut, um es noch einmal zu versuchen.',
        addPart: '„{{name}}“ als neuen Part hinzufügen',
        partAdded: '{{name}} als Part hinzugefügt',
        newPropertyKind: 'Art der Größe für eine neue Eigenschaft',
        newPropertyKindHelp: 'Wird nur verwendet, wenn du oben eine neue Eigenschaft hinzufügst.',
        noKind: 'Keine',
      },
    },
    dimensionWords: {
      length: 'Länge',
      mass: 'Masse',
      time: 'Zeit',
      amountOfSubstance: 'Stoffmenge',
      electricCurrent: 'elektrische Stromstärke',
      temperature: 'Temperatur',
      luminousIntensity: 'Lichtstärke',
      dimensionless: 'dimensionslos',
      per: 'pro',
    },
    unitTabs: {
      label: 'Einheiten und Molmassen',
      units: 'Einheitenliste',
      molarMasses: 'Molmassen',
    },
    unitList: {
      subtitle: 'Die Einheiten, in denen Werte für jede Organisation erfasst werden können, mit ihrer Dimension. Welche Messung welche nutzt, legst du bei der Messung fest.',
      noUcum: 'Kein UCUM-Code',
      noDimension: 'Keine Dimension',
      columns: {
        quantityKinds: 'Größen',
      },
    },
    unitDialog: {
      dimensionHelp: 'Bei einer Einheit ohne UCUM-Code gibst du die Dimension hier ein. Einheiten gleicher Dimension lassen sich ineinander umrechnen.',
      noDimension: 'Keine Dimension',
      ucumHelp: 'Ein Code aus der UCUM-Version der Plattform, zum Beispiel kg. Keine zwei Einheiten teilen sich einen Code.',
      noUcum: 'Diese Einheit hat keinen UCUM-Code. Füge einen hinzu, falls sie einen hat, zum Beispiel kg.',
      workedOut: 'Aus dem UCUM-Code berechnet.',
      workedOutAfterSave: 'Wird beim Speichern berechnet.',
      quantityKinds: 'Größen, die sie ausdrücken darf',
      quantityKindsHelp: 'Eine Einheit passt zu einer Messung, wenn sie die Größe ausdrücken darf, die die Messung nennt. Aus QUDT übernommen oder hier gewählt.',
      dimensionsFailed: 'Die Dimensionen konnten nicht gelesen werden, daher kann keine gewählt werden.',
      dimensionsRetry: 'Erneut versuchen',
    },
    measurementUnits: {
      add: 'Einheit verknüpfen',
      edit: 'Verknüpfung bearbeiten',
      remove: 'Verknüpfung entfernen',
      isDefault: 'Kanonisch',
      columns: {
        isDefault: 'Kanonisch',
        conversion: 'Umrechnung in die kanonische Einheit',
        approvedBy: 'Freigegeben von',
        validMinimum: 'Gültig ab',
        validMaximum: 'Gültig bis',
      },
      confirm: 'Faktor bestätigen',
      confirmedToast: 'Faktor für {{unit}} bestätigt',
      factor: '1 {{from}} = {{multiplier}} {{to}}',
      factorWithOffset: '({{from}} + {{offset}}) × {{multiplier}} = {{to}}',
      viaAlgebra: 'Aus den UCUM-Codes berechnet.',
      viaMolarMass: 'Über die Molmasse von {{analyte}}, {{mass}} g/mol. Quelle: {{source}}.',
      formula: '{{factor}}. {{via}}',
      approved: '{{by}}, {{date}}',
      notApproved: 'Noch nicht freigegeben',
      unavailable: {
        dimensionDiffers: 'Kein Faktor: Diese Einheit hat eine andere Dimension als die kanonische Einheit.',
        noCanonicalUnit: 'Noch kein Faktor: Die Messung hat keine kanonische Einheit.',
        noMolarMass: 'Noch kein Faktor: Die Molmasse des Analyten ist nicht hinterlegt.',
        noDimension: 'Kein Faktor: Diese Einheit hat keine Dimension.',
      },
      enterMolarMass: 'Molmasse eingeben',
      removeDialog: {
        title: 'Diese Verknüpfung entfernen?',
      },
    },
    unitLinkDialog: {
      isDefault: 'Kanonische Einheit: Werte werden darin angezeigt und ihr Bereich wird geprüft',
      isDefaultHelp: 'Die erste Einheit einer Messung ist ihre kanonische Einheit. Es gibt nur eine.',
      otherDefault: 'Eine andere Einheit ist die kanonische. Schalte sie dort zuerst aus.',
      validMinimum: 'Gültiges Minimum',
      validMaximum: 'Gültiges Maximum',
      validHelp: 'Optional. Der niedrigste Wert, der erfasst werden kann, in {{unit}}. Ein Wert in einer anderen Einheit wird zuerst umgerechnet.',
      rangeWrong: 'Das Minimum ist höher als das Maximum.',
    },
    molarMasses: {
      title: 'Molmassen',
      subtitle: 'Eine Massenkonzentration trifft über die Molmasse auf eine Stoffmengenkonzentration desselben Analyten. Jede Masse hat ihre Quelle.',
      add: 'Molmasse hinzufügen',
      edit: 'Molmasse bearbeiten',
      remove: 'Molmasse entfernen',
      addTitle: 'Eine Molmasse hinzufügen',
      editTitle: 'Molmasse von {{name}} bearbeiten',
      columns: {
        analyte: 'Analyt',
        gramsPerMole: 'Gramm pro Mol',
        source: 'Quelle',
      },
      analyte: 'Analyt',
      analyteHelp: 'Suche nach Name oder Part-Nummer, zum Beispiel Glucose.',
      gramsPerMole: 'Gramm pro Mol',
      massHelp: 'Für Glucose: 180.156.',
      massWrong: 'Gib eine Zahl über 0 ein, mit bis zu zehn Stellen vor und nach dem Komma.',
      source: 'Quelle',
      sourceHelp: 'Woher die Zahl stammt: eine LOINC-Gruppe, eine ChEBI- oder PubChem-Kennung, ein Nachschlagewerk.',
      removeDialog: {
        title: 'Diese Molmasse entfernen?',
        message: '{{name}} hat keine Molmasse mehr. Faktoren, die sie nutzen, lassen sich nicht mehr berechnen.',
      },
    },
  },
  tenantSettings: {
    title: 'Tenant-Einstellungen',
    subtitle: 'Einstellungen verwalten',
    loadError: 'Fehler beim Laden der Tenant-Einstellungen. Sie haben möglicherweise keine Berechtigung, diesen Tenant anzuzeigen.',
    generalInfo: 'Allgemeine Informationen',
    tenantName: 'Tenant-Name',
    organisation: 'Organisation',
    organisationHelper: 'Organisation kann nicht geändert werden',
    tenantId: 'Tenant-ID',
    yourRole: 'Ihre Rolle',
    roleDescription: 'Ihre Rolle in dieser Organisation ist {{role}}.',
    permissionsConfigured: 'Was diese Rolle darf, legt die Organisation selbst fest. Ein Administrator sieht und ändert es im Rollen-Bildschirm.',
    saveName: 'Namen speichern',
    nameSaved: 'Der Name des Mandanten wurde aktualisiert.',
    saveError: 'Der Name konnte nicht gespeichert werden. Möglicherweise dürfen Sie ihn nicht ändern.',
  },
  communityUsers: {
    title: 'Community-Benutzer',
    subtitle: 'Alle Benutzer mit einem Konto auf der Plattform. Persönliche Details werden nur basierend auf den Datenschutzeinstellungen jedes Benutzers angezeigt.',
    loadError: 'Fehler beim Laden der Community-Benutzer. Bitte versuchen Sie es erneut.',
    view: 'Ansehen',
    noUsersTitle: 'Keine geteilten Benutzer',
    noUsersNotice: 'Niemand hat seine Daten bisher zur Ansicht freigegeben.',
  },
  adminDashboard: {
    menuItems: {
      questionnaires: 'Fragebögen',
      tenants: 'Mandanten',
      organisations: 'Organisationen',
      users: 'Systembenutzer',
    },
    users: {
      title: 'Systembenutzer',
      comingSoon: 'Benutzerverwaltung kommt bald...',
    },
  },
  organisationDialog: {
    titleCreate: 'Neue Organisation Erstellen',
    titleEdit: 'Organisation bearbeiten',
    emailInvalid: 'Geben Sie eine E-Mail-Adresse ein, etwa name@beispiel.de',
    dateInvalid: 'Geben Sie ein Datum ein',
    legalNameRequired: 'Firmenname ist erforderlich',
    createError: 'Fehler beim Erstellen der Organisation. Bitte überprüfen Sie, ob eindeutige Felder bereits verwendet werden.',
    fields: {
      legalName: 'Firmenname',
      tradeName: 'Handelsname',
      taxId: 'Steuernummer',
      referenceCode: 'Referenzcode',
      emailAddress: 'E-Mail-Adresse',
      phoneNumber: 'Telefonnummer',
      website: 'Website',
      practiceCode: 'Praxiscode',
      chamberOfCommerceNumber: 'Handelsregisternummer',
      subscriptionDate: 'Abonnementdatum',
      active: 'Aktiv',
    },
    actions: {
      create: 'Erstellen',
    },
  },
  organisationList: {
    title: 'Organisationen',
    addButton: 'Organisation hinzufügen',
    updateSuccess: 'Organisation erfolgreich aktualisiert',
    updateError: 'Fehler beim Aktualisieren der Organisation',
    columns: {
      legalName: 'Rechtsname',
      tradeName: 'Handelsname',
      taxId: 'Steuernummer',
      referenceCode: 'Referenzcode',
      emailAddress: 'E-Mail',
      phoneNumber: 'Telefon',
      website: 'Webseite',
      practiceCode: 'Praxiscode',
      chamberOfCommerceNumber: 'Handelsregisternummer',
      subscriptionDate: 'Abonnementdatum',
      status: 'Status',
    },
    statusLabels: {
      active: 'Aktiv',
      inactive: 'Inaktiv',
    },
    edit: 'Bearbeiten',
    deactivate: 'Deaktivieren',
    alreadyInactive: 'Bereits inaktiv. Über Bearbeiten wieder aktivieren.',
    deactivateTitle: 'Organisation deaktivieren',
    deactivateMessage: '{{name}} wird als inaktiv markiert. Nichts davon wird entfernt, und über Bearbeiten können Sie sie wieder aktivieren.',
    deactivated: 'Organisation deaktiviert',
    created: 'Organisation erstellt',
  },
  questionnaireEditor: {
    questionsCount: 'Fragen ({{count}})',
    addQuestionButton: 'Frage hinzufügen',
    emptyState: {
      message: 'Noch keine Fragen. Fügen Sie Ihre erste Frage hinzu!',
      button: 'Frage hinzufügen',
    },
    question: {
      prefix: 'Frage',
      required: 'Erforderlich',
      identity: 'Identität: ',
      optionsLabel: 'Optionen:',
    },
    tooltips: {
      edit: 'Bearbeiten',
      delete: 'Löschen',
    },
    dialog: {
      titleNew: 'Neue Frage',
      titleEdit: 'Frage bearbeiten',
      questionType: 'Fragetyp',
      questionPrompt: 'Fragetext',
      requiredQuestion: 'Pflichtfrage',
      identityField: 'Dies ist ein Identitätsfeld (für Benutzer-Onboarding)',
      identityFieldType: 'Identitätsfeldtyp',
      listOptionsTitle: 'Listenoptionen',
      addOptionButton: 'Option hinzufügen',
      codeLabel: 'Code',
      codePlaceholder: 'z.B., SAT_HOCH',
      valueLabel: 'Anzeigewert',
      valuePlaceholder: 'z.B., Sehr zufrieden',
      emptyOptions: 'Fügen Sie mindestens eine Option für Dropdown-Fragen hinzu',
      cancel: 'Abbrechen',
      save: 'Speichern',
      create: 'Erstellen',
      removeOption: 'Option entfernen',
    },
    deleteDialog: {
      title: 'Frage löschen',
      message: 'Sind Sie sicher, dass Sie diese Frage löschen möchten? Dadurch werden auch alle zugehörigen Antworten gelöscht.',
      cancel: 'Abbrechen',
      delete: 'Löschen',
    },
    messages: {
      updateSuccess: 'Frage erfolgreich aktualisiert',
      createSuccess: 'Frage erfolgreich erstellt',
      deleteSuccess: 'Frage erfolgreich gelöscht',
      saveError: 'Fehler beim Speichern der Frage',
      deleteError: 'Fehler beim Löschen der Frage',
    },
    questionTypes: {
      text: 'Text',
      number: 'Nummer',
      date: 'Datum',
      list: 'Liste/Dropdown',
      boolean: 'Ja/Nein',
    },
    identityTypes: {
      first_name: 'Vorname',
      last_name: 'Nachname',
      email: 'E-Mail',
      date_of_birth: 'Geburtsdatum',
    },
  },
  questionnaireList: {
    title: 'Fragebögen',
    newButton: 'Fragebogen hinzufügen',
    table: {
      name: 'Name',
      description: 'Beschreibung',
      status: 'Status',
      version: 'Version',
      publicLink: 'Öffentlicher Link',
    },
    statusLabels: {
      active: 'Aktiv',
      inactive: 'Inaktiv',
    },
    dialog: {
      titleNew: 'Fragebogen hinzufügen',
      titleEdit: 'Fragebogen bearbeiten',
      name: 'Name',
      description: 'Beschreibung',
      active: 'Aktiv',
      create: 'Erstellen',
      nameRequired: 'Geben Sie einen Namen ein',
      publicLink: 'Öffentlicher Link',
      noPublicLink: 'Dieser Fragebogen hat noch keinen öffentlichen Link.',
      newLink: 'Beim Speichern einen neuen Link erstellen. Der aktuelle Link funktioniert dann nicht mehr.',
      makeLink: 'Beim Speichern einen öffentlichen Link erstellen',
    },
    deleteDialog: {
      title: 'Fragebogen entfernen',
      message: '{{name}} und seine Fragen werden entfernt. Ein Fragebogen, den Personen beantwortet haben, wird nicht entfernt; deaktivieren Sie ihn stattdessen.',
      delete: 'Entfernen',
    },
    messages: {
      updateSuccess: 'Fragebogen erfolgreich aktualisiert',
      createSuccess: 'Fragebogen erfolgreich erstellt',
      deleteSuccess: 'Fragebogen entfernt',
      saveError: 'Fehler beim Speichern des Fragebogens',
      linkCopied: 'Link in Zwischenablage kopiert',
      copyFailed: 'Der Link konnte nicht kopiert werden',
    },
    copyLink: 'Link kopieren',
    copyLinkOf: 'Öffentlichen Link von {{name}} kopieren',
    noLink: 'Keiner',
    edit: 'Bearbeiten',
    delete: 'Entfernen',
    noOrganisationTitle: 'Noch keine Organisation',
    noOrganisationNotice: 'Fragebögen gehören zu einer Organisation, und dieses Konto gehört zu keiner.',
  },
  submissionViewer: {
    table: {
      id: 'ID',
      status: 'Status',
      email: 'E-Mail',
      name: 'Name',
      submittedAt: 'Eingereicht am',
    },
    statusLabels: {
      submitted: 'Eingereicht',
      draft: 'Entwurf',
      scored: 'Bewertet',
      abandoned: 'Abgebrochen',
    },
    dialog: {
      title: 'Einreichung - Antworten',
      submissionDetails: 'Einreichungsdetails',
      status: 'Status',
      submittedAt: 'Eingereicht am',
      notYetSubmitted: 'Noch nicht eingereicht',
      email: 'E-Mail',
      name: 'Name',
      answersCount: 'Antworten ({{count}})',
      noAnswers: 'Noch keine Antworten eingereicht.',
      questionPrefix: 'Frage {{number}}',
      close: 'Schließen',
      unknownQuestion: 'Eine Frage, die nicht mehr in diesem Fragebogen steht',
    },
    booleanValues: {
      yes: 'Ja',
      no: 'Nein',
    },
    answersFailed: 'Die Antworten konnten nicht geladen werden',
    openAnswers: 'Antworten vom {{sent}}',
  },
  tenantList: {
    title: 'Mandanten',
    addButton: 'Mandant Hinzufügen',
    saveError: 'Fehler beim Speichern des Mandanten',
    noOrganisationsWarning: 'Keine Organisationen verfügbar. Erstellen Sie zuerst eine Organisation, bevor Sie Mandanten hinzufügen.',
    table: {
      id: 'ID',
      name: 'Name',
      organisation: 'Organisation',
    },
    tooltips: {
      edit: 'Bearbeiten',
    },
    dialog: {
      titleCreate: 'Mandant Erstellen',
      titleEdit: 'Mandant Bearbeiten',
      tenantName: 'Mandantenname',
      organisation: 'Organisation',
      create: 'Erstellen',
      nameRequired: 'Geben Sie einen Namen ein',
      organisationRequired: 'Wählen Sie eine Organisation',
      organisationLocked: 'Ein Mandant bleibt bei seiner Organisation',
    },
    messages: {
      created: 'Mandant hinzugefügt',
      updated: 'Mandant gespeichert',
    },
  },
  publicQuestionnairePage: {
    loading: 'Laden...',
    invalidLink: 'Ungültiger Fragebogen-Link',
    notFound: 'Fragebogen nicht gefunden oder nicht mehr aktiv',
    checkLink: 'Bitte überprüfen Sie den Link und versuchen Sie es erneut.',
    thankYou: 'Vielen Dank!',
    submitted: 'Ihre Antworten wurden erfolgreich eingereicht.',
    newAccountCreated: 'Ein neues Konto wurde für Sie erstellt. Überprüfen Sie Ihre E-Mail für Anmeldeanweisungen.',
    progress: 'Fortschritt',
    questions: 'Fragen',
    required: 'Dieses Feld ist erforderlich',
    identityFieldInfo: 'Diese Informationen werden verwendet, um Ihr Konto zu erstellen',
    submitButton: 'Fragebogen Einreichen',
    submitting: 'Wird eingereicht...',
    autoSave: 'Ihre Antworten werden automatisch gespeichert, während Sie tippen',
    missingRequired: 'Bitte beantworten Sie alle erforderlichen Fragen ({{count}} verbleibend)',
    submitError: 'Fehler beim Einreichen des Fragebogens. Bitte versuchen Sie es erneut.',
    placeholders: {
      text: 'Geben Sie Ihre Antwort ein...',
      number: 'Geben Sie eine Zahl ein...',
      email: 'Geben Sie Ihre E-Mail ein',
      firstName: 'Geben Sie Ihren Vornamen ein',
      lastName: 'Geben Sie Ihren Nachnamen ein',
      dateOfBirth: 'Geben Sie Ihr Geburtsdatum ein',
    },
    booleanValues: {
      yes: 'Ja',
      no: 'Nein',
    },
    answerSaveFailed: 'Ihre Antwort konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.',
  },
  manageProgrammeMeasurements: {
    title: 'Programmmessungen',
    tenant: 'Mieter',
    addButton: 'Programmmessung Hinzufügen',
    noProgrammes: 'Keine Programme verfügbar. Bitte erstellen Sie zuerst ein Programm.',
    noOrganisationTitle:
      'Noch keine Organisation',
    noOrganisation: 'Programmmessungen gehören zu einer Organisation, und dieses Konto gehört zu keiner.',
    rolesUnknownTitle: 'Ihre Rollen nicht gelesen',
    rolesUnknownNotice:
      'Ohne sie weiß dieser Bildschirm nicht, welche Organisation er zeigen soll — das ist nicht dasselbe wie zu keiner zu gehören.',
    table: {
      programmeName: 'Programmname',
      measurementName: 'Messungsname',
      loincCode: 'LOINC-Code',
      minimumTarget: 'Minimalziel',
      maximumTarget: 'Maximalziel',
      defaultUnit: 'Standardeinheit',
      reminder: 'Erinnerung',
      everyWeeks: 'Alle {{count}} Wochen: {{days}}',
    },
    actions: {
      edit: 'Bearbeiten',
      delete: 'Löschen',
    },
    dialog: {
      titleAdd: 'Programmmessung Hinzufügen',
      titleEdit: 'Programmmessung Bearbeiten',
      programme: 'Programm',
      measurement: 'Messung',
      minimumTarget: 'Minimalziel',
      maximumTarget: 'Maximalziel',
      defaultUnit: 'Standardeinheit',
      selectProgramme: 'Programm auswählen',
      selectMeasurement: 'Messung auswählen',
      measurementSearchHint: 'Tippe mindestens drei Buchstaben des Namens oder des Codes.',
      measurementNoMatch: 'Keine Messung passt.',
      measurementSearchFailed: 'Die Messungen konnten nicht gelesen werden. Tippe erneut, um es noch einmal zu versuchen.',
      selectUnit: 'Einheit auswählen',
      repeatEvery: 'Wiederholen alle',
      weeks: 'Wochen',
      repeatOn: 'Wiederholen am',
      ends: 'Endet',
      endsProgrammeEnd: 'Wenn das Programm endet',
      endsOn: 'Am',
      endsAfter: 'Nach',
      occurrences: 'Wiederholungen',
      timeOfDay: 'Um',
      timeOfDayOptional: 'optional',
      selectWeekdaysFirstWarning: 'Wählen Sie zuerst einen Wochentag',
      recurrenceHint: 'Wählen Sie keine Tage, um keinen Zeitplan zu speichern. Wochen werden ab der Startwoche des Programms gezählt.',
      programmeHasNoEndDate: 'Dieses Programm hat kein Enddatum und wird daher unbegrenzt wiederholt',
      save: 'Speichern',
      update: 'Aktualisieren',
    },
    deleteConfirm: 'Möchten Sie die Messung "{{measurementName}}" wirklich aus dem Programm "{{programmeName}}" löschen?',
    deleteTitle: 'Diese Messung aus dem Programm entfernen?',
    messages: {
      loadRolesFailed: 'Fehler beim Laden der Mieterrollen',
      loadDataFailed: 'Fehler beim Laden der Daten',
      partlyRead: 'Die Messungen einiger Programme konnten nicht gelesen werden, daher ist diese Liste möglicherweise unvollständig.',
      noTenantSelected: 'Kein Mieter ausgewählt',
      selectProgrammeError: 'Bitte wählen Sie ein Programm aus',
      selectMeasurementError: 'Bitte wählen Sie eine Messung aus',
      selectUnitError: 'Bitte wählen Sie eine Standardeinheit aus',
      recurrenceIntervalError: 'Wiederholen alle muss eine ganze Zahl von 1 bis 52 Wochen sein',
      recurrenceEndDateError: 'Wählen Sie ein Enddatum, das nicht vor dem Programmstart liegt',
      recurrenceOccurrencesError: 'Die Anzahl der Wiederholungen muss eine ganze Zahl von 1 bis 520 sein',
      deleteSuccess: 'Programmmessung erfolgreich gelöscht',
      addSuccess: 'Programmmessung erfolgreich hinzugefügt',
      addFailed: 'Fehler beim Hinzufügen der Programmmessung',
      updateSuccess: 'Programmmessung erfolgreich aktualisiert',
      updateFailed: 'Fehler beim Aktualisieren der Programmmessung',
      notAllowed: 'Das darfst du nicht ändern.',
    },
  },
  manageProgrammeDialog: {
    titleCreate: 'Neues Programm Erstellen',
    titleEdit: 'Programm Bearbeiten',
    programmeName: 'Programmname',
    programmeNameRequired: 'Programmname ist erforderlich',
    description: 'Beschreibung',
    targetAudience: 'Zielgruppe',
    startDate: 'Startdatum',
    startDateRequired: 'Startdatum ist erforderlich',
    startDateLocked:
      'Das Startdatum kann nach der Erstellung nicht mehr geändert werden',
    endDate: 'Enddatum',
    endDateHelper: 'Leer lassen für laufende Programme',
    endDateError: 'Enddatum muss nach dem Startdatum liegen',
    startDatePast: 'Startdatum darf nicht in der Vergangenheit liegen',
    endDatePast: 'Enddatum darf nicht in der Vergangenheit liegen',
    saveChanges: 'Änderungen Speichern',
    createProgramme: 'Programm Erstellen',
    saveFailed: 'Fehler beim Speichern des Programms',
    banner: {
      label: 'Banner',
      choose: 'Bild auswählen',
      remove: 'Banner entfernen',
      none: 'Noch kein Banner. Mitglieder sehen den Namen des Programms in der Farbe des Tenants.',
      accepted: 'PNG, WebP oder JPEG, höchstens 2 MB, zwischen 800 × 200 und 6000 × 6000 Pixel.',
      refused: 'Diese Datei kann nicht verwendet werden. Wählen Sie ein PNG-, WebP- oder JPEG-Bild mit höchstens 2 MB und zwischen 800 × 200 und 6000 × 6000 Pixeln.',
      saveFailed: 'Das Banner konnte nicht gespeichert werden. Versuchen Sie es erneut.',
    },
  },
  manageProgrammes: {
    title: 'Programme',
    addButton: 'Programm Hinzufügen',
    tenant: 'Mieter',
    loadRolesFailed: 'Fehler beim Laden der Mieterrollen',
    loadProgrammesFailed: 'Fehler beim Laden der Programme',
    table: {
      programmeName: 'Programmname',
      description: 'Beschreibung',
      target: 'Ziel',
      startDate: 'Startdatum',
      endDate: 'Enddatum',
    },
    actions: {
      edit: 'Bearbeiten',
      delete: 'Löschen',
    },
    deleteDialog: {
      title: 'Programm Löschen',
      message: 'Möchten Sie das Programm "{{programmeName}}" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
      delete: 'Löschen',
    },
    messages: {
      createSuccess: 'Programm erfolgreich erstellt',
      updateSuccess: 'Programm erfolgreich aktualisiert',
      deleteSuccess: 'Programm erfolgreich gelöscht',
    },
    ongoing: 'Laufend',
    loadFailedTitle: 'Programme nicht gelesen',
    noOrganisationNotice: 'Programme gehören zu einer Organisation, und dieses Konto gehört zu keiner.',
    noOrganisationTitle: 'Noch keine Organisation',
    rolesUnknownNotice: 'Ohne sie weiß dieser Bildschirm nicht, was Sie verwalten — das ist nicht dasselbe wie nichts zu verwalten.',
    rolesUnknownTitle: 'Ihre Rollen nicht gelesen',
  },
  programmesOverview: {
    title: 'Verfügbare Programme',
    loadFailed: 'Fehler beim Laden der Programme',
    enrollFailed: 'Fehler bei der Einschreibung in das Programm',
    enroll: 'Einschreiben',
    unenroll: 'Abmelden',
    unenrollFailed: 'Abmeldung vom Programm fehlgeschlagen',
    preview: 'Vorschau',
    table: {
      programmeName: 'Programmname',
      target: 'Ziel',
      programmeStartDate: 'Programm-Startdatum',
      programmeEndDate: 'Programm-Enddatum',
      enrollmentStatus: 'Einschreibungsstatus',
    },
    status: {
      notEnrolled: 'Nicht Eingeschrieben',
      active: 'Aktiv',
      inactive: 'Inaktiv',
    },
    previewPanel: {
      enrolledFrom: 'Sie sind für dieses Programm eingeschrieben seit:',
      ongoing: 'Heute',
    },
    noProgrammesNotice: 'Ihre Organisation hat noch keine Programme zur Anmeldung geöffnet.',
    noProgrammesTitle: 'Noch keine Programme',
    programmesUnknownNotice: 'Die Liste ist nicht angekommen — das ist nicht dasselbe wie keine zu haben.',
    programmesUnknownTitle: 'Programme nicht gelesen',
    retry: 'Erneut versuchen',
    close: 'Schließen',
    confirmUnenroll: {
      title: 'Dieses Programm verlassen?',
      body: 'Sie werden von {{programme}} abgemeldet. Sie können sich später erneut anmelden.',
      cancel: 'Abbrechen',
      confirm: 'Abmelden',
    },
  },
  observations: {
    addObservation: 'Messung hinzufügen',
    viewToggleLabel: 'Ansicht',
    viewCalendar: 'Kalender',
    viewStack: 'Stapel',
    viewTimeline: 'Zeitleiste',
    filter: {
      title: 'Filtern',
      label: 'Programme',
      all: 'Alle Programme',
    },
    submitting: 'Wird gesendet...',
    searchBy: 'Suchen nach',
    searchValue: 'Suchwert',
    columns: 'Spalten',
    columnsLabel: 'Angezeigte Spalten Ändern',
    eventType: 'Ereignistyp',
    dateTime: 'Datum Uhrzeit',
    measurementType: 'Messungstyp',
    value: 'Wert',
    sourceDocument: 'Quelldokument',
      sourceDocumentDescription: 'Dokumentbeschreibung',
    actions: 'Aktionen',
    eventTypes: {
      manualInput: 'Manuelle Eingabe',
      deviceSync: 'Gerätesynchronisation',
      uploaded: 'Hochgeladen',
      coachingSession: 'Coaching-Sitzung',
    },
    validation: {
      eventTypeRequired: 'Ereignistyp ist erforderlich',
      dateTimeRequired: 'Datum und Uhrzeit sind erforderlich',
      invalidDateTime: 'Ungültiges Datum und Uhrzeit',
      atLeastOneMeasurement: 'Geben Sie mindestens einen Messwert ein',
      invalidValue: 'Ungültiger Wert',
      validationFailed: 'Validierung fehlgeschlagen',
      fixErrors: 'Bitte beheben Sie alle Validierungsfehler vor dem Absenden',
    },
    messages: {
      noChanges: 'Keine Änderungen zum Speichern',
      successSingle: 'Beobachtung erfolgreich gespeichert',
      successMultiple: 'Alle Beobachtungseinträge erfolgreich eingereicht!',
      submitError: 'Fehler beim Absenden der Beobachtungen',
      updateError: 'Fehler beim Aktualisieren der Beobachtung',
      deleteSuccess: 'Beobachtung erfolgreich gelöscht',
      removeSuccess: 'Beobachtung entfernt',
      deleteError: 'Fehler beim Löschen der Beobachtung',
      loadError: 'Fehler beim Laden der Beobachtungen',
      networkError: 'Netzwerkfehler aufgetreten',
      saveError: 'Fehler beim Speichern der Änderungen',
    },
    dialog: {
      deleteTitle: 'Beobachtung Löschen',
      deleteMessage: 'Sind Sie sicher, dass Sie dieses Beobachtungsereignis löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
      cancel: 'Abbrechen',
      delete: 'Löschen',
    },
    dayView: {
      previousDay: 'Vorheriger Tag',
      nextDay: 'Nächster Tag',
      today: 'Heute',
      noEntries: 'An diesem Tag wurden keine Beobachtungen erfasst',
      edit: 'Bearbeiten',
      save: 'Speichern',
      dataTypeNumber: 'Zahl',
      dataTypeText: 'Text',
      dataTypeBoolean: 'Ja/Nein',
      noProgramme: 'Kein Programm',
      noValues: 'Keine Werte erfasst',
      newMeasurementTitle: 'Neue Messung',
      previewPending: 'Noch nicht gespeichert',
      programme: 'Programm',
      selectProgramme: 'Programm auswählen',
      measurement: 'Messung',
      selectMeasurement: 'Messung auswählen',
      noMeasurementSelected: 'Wählen Sie eine Messung aus, bevor Sie einen Wert eingeben',
      noProgrammeSelected: 'Wählen Sie ein Programm aus, bevor Sie eine Messung auswählen',
      value: 'Wert',
      viewLabel: 'Ansicht',
      viewDay: 'Tag',
      viewWeek: 'Woche',
      viewMonth: 'Monat',
      previousWeek: 'Vorherige Woche',
      nextWeek: 'Nächste Woche',
      previousMonth: 'Vorheriger Monat',
      nextMonth: 'Nächster Monat',
      noEntriesRange: 'Keine Beobachtungen in diesem Zeitraum erfasst',
      legendTitle: 'Programme',
      legendScheduledLabel: 'Geplante Messung',
      legendNotInProgramme: 'Nicht in einem Programm',
      dueLabel: 'Zu erfassen',
      doneLabel: 'Erledigt',
      dueTooltip: '{{measurement}} — {{programme}}',
      recordDue: '{{measurement}} erfassen',
      slotHint: 'Klicken Sie auf eine freie Zeit im Kalender, um etwas Neues zu erfassen',
      moreEvents: '+{{count}} weitere',
    },
  },
  settings: {
    title: 'Sprach- und Regionseinstellungen',
    language: 'Sprache',
    region: 'Region',
    systemOfMeasurement: 'Maßsystem',
    timezone: 'Zeitzone',
    metricSystem: 'Metrisches System',
    imperialSystem: 'Imperiales System',
    usCustomaryUnits: 'US-übliche Einheiten',
    regionInfoTitle: 'Regionsinformationen',
    regionInfoText: 'Wählen Sie Ihre Region, um Zahlen, Datumsangaben und Zeiten in lokalen Formaten anzuzeigen (z.B. USA: 1,234.56, 03/07/2025, 5:30 PM; Deutschland: 1.234,56, 07.03.2025, 17:30).',
    regionInfo: 'Wählen Sie Ihre Region, um Zahlen, Datumsangaben und Zeiten in lokalen Formaten anzuzeigen.',
    selectLanguage: 'Sprache Auswählen',
    selectRegion: 'Region Auswählen',
    selectMeasurement: 'Maßsystem Auswählen',
    selectTimezone: 'Zeitzone Auswählen',
    preview: 'Vorschau',
    formatExamples: 'Format-Beispiele',
    save: 'Speichern',
    cancel: 'Abbrechen',
    saving: 'Speichern...',
    savedSuccessfully: 'Einstellungen erfolgreich gespeichert!',
    saveSuccess: 'Einstellungen erfolgreich gespeichert!',
    warningTitle: 'Änderungen Bestätigen',
    warningMessage: 'Diese Änderungen treten sofort in Kraft. Sprachänderungen aktualisieren die Benutzeroberfläche sofort, während regionale und Messungseinstellungen auf alle angezeigten Daten angewendet werden.',
    confirmSave: 'Änderungen Speichern',
    languageLabel: 'Sprache',
    regionLabel: 'Region',
    measurementLabel: 'Messung',
    numberLabel: 'Nummer',
    dateLabel: 'Datum',
    timeLabel: 'Zeit',
    weightLabel: 'Gewicht',
    heightLabel: 'Größe',
    distanceLabel: 'Entfernung',
    temperatureLabel: 'Temperatur',
    saveFailed: 'Ihre Einstellungen konnten nicht gespeichert werden.',
    languageSaveFailed: 'Ihre Sprachwahl konnte nicht gespeichert werden.',
  },
  actions: {
    add: 'Hinzufügen',
    view: 'Anzeigen',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    save: 'Speichern',
    cancel: 'Abbrechen',
    close: 'Schließen',
    open: 'Öffnen',
  },
  recordPage: {
    path: 'Pfad',
    general: 'Allgemein',
  },
  programmePage: {
    measurements: 'Messungen',
    dashboards: 'Dashboard',
    notFoundTitle: 'Dieses Programm wurde nicht gefunden',
    notFoundBody: 'Es wurde vielleicht entfernt, oder es gehört zu einer anderen Organisation.',
    loadFailedTitle: 'Dieses Programm konnte nicht gelesen werden',
    loadFailed: 'Versuchen Sie es gleich erneut.',
  },
  programmeBoards: {
    loading: 'Das Dashboard wird geladen',
    panelTitle: 'Das Dashboard dieses Programms',
    panelHint: 'Jedes Mitglied dieses Programms findet es auf seinem Dashboard, sobald ein Baustein darauf ist. Gespeichertes sehen sie sofort.',
    name: 'Name',
    nameHint: 'Leer gelassen trägt es den Namen des Programms.',
    unsaved: 'Nicht gespeichert',
    save: 'Speichern',
    discard: 'Änderungen verwerfen',
    saved: 'Gespeichert. Mitglieder dieses Programms sehen es jetzt.',
    saveFailed: 'Das Dashboard konnte nicht gespeichert werden. Versuchen Sie es erneut.',
    emptyTitle: 'Dieses Dashboard ist noch leer',
    emptyBody: 'Wählen Sie oben einen Baustein. Mitglieder sehen das Dashboard, sobald einer darauf ist.',
    deniedTitle: 'Sie können das Dashboard dieses Programms nicht ändern',
    deniedBody: 'Dafür brauchen Sie das Recht, dieses Programm einzurichten.',
    loadFailedTitle: 'Das Dashboard konnte nicht gelesen werden',
    retry: 'Erneut versuchen',
    galleryHint: 'Wählen Sie einen Baustein, um ihn unten auf dieses Dashboard zu setzen. Jeder zeigt eine Messung dieses Programms.',
    arrangeHint: 'Ziehen Sie einen Baustein am Griff oder an der rechten unteren Ecke. Jedes Mitglied sieht darin seine eigenen Werte.',
    noMeasurements: 'Dieses Programm erfasst noch keine Messung. Fügen Sie zuerst eine im Tab Messungen hinzu.',
  },
  questionnairePage: {
    questions: 'Fragen',
    submissions: 'Einreichungen',
    notFoundTitle: 'Dieser Fragebogen wurde nicht gefunden',
    notFoundBody: 'Er wurde vielleicht entfernt, oder er gehört zu einer anderen Organisation.',
    loadFailedTitle: 'Dieser Fragebogen konnte nicht gelesen werden',
    loadFailed: 'Versuchen Sie es gleich erneut.',
  },
  tenantPage: {
    administrators: 'Administratoren',
    notFoundTitle: 'Dieser Mandant wurde nicht gefunden',
    notFoundBody: 'Er wurde vielleicht entfernt, oder die Adresse stimmt nicht.',
    loadFailedTitle: 'Dieser Mandant konnte nicht gelesen werden',
    loadFailed: 'Versuchen Sie es gleich erneut.',
    table: {
      name: 'Name',
      email: 'E-Mail',
    },
    addButton: 'Administrator hinzufügen',
    remove: 'Entfernen',
    removeTitle: 'Administrator entfernen',
    removeMessage: '{{name}} verwaltet {{tenant}} dann nicht mehr. Das Konto und die Verbindung zur Organisation bleiben bestehen.',
    removed: 'Administrator entfernt',
    added: 'Administrator hinzugefügt',
    add: {
      title: 'Administrator für {{tenant}} hinzufügen',
      person: 'Person',
      personRequired: 'Wählen Sie eine Person',
      nobody: 'In dieser Organisation kann niemand gewählt werden.',
      peopleFailed: 'Die Personen dieser Organisation konnten nicht gelesen werden.',
      save: 'Hinzufügen',
      failed: 'Der Administrator konnte nicht hinzugefügt werden.',
    },
  },
  grid: {
    noRowsTitle: 'Noch nichts',
    noRowsNotice: 'Zeilen erscheinen, sobald es etwas zu zeigen gibt.',
    noResultsTitle: 'Keine Treffer',
    noResultsNotice: 'Suchen Sie kürzer, oder löschen Sie die Filter.',
    actions: 'Aktionen',
    edit: 'Bearbeiten',
    remove: 'Entfernen',
    clearSearch: 'Suche löschen',
    cancel: 'Abbrechen',
    save: 'Speichern',
    saving: 'Speichern…',
    actionFailed: 'Das hat nicht geklappt. Es wurde nichts geändert.',
    loadFailedTitle: 'Diese Liste konnte nicht gelesen werden',
    add: 'Hinzufügen',
    filter: 'Filter',
    searchAll: 'Alle Spalten durchsuchen',
    sortByField: 'Sortieren nach: {{field}}',
    sortByFieldDirection: 'Sortieren nach: {{field}}, {{direction}}',
    filterWithCount: 'Filter ({{count}})',
    newestFirst: 'Neueste zuerst',
    noResultsFor: 'Keine Ergebnisse für „{{query}}“',
    clearSearchAndFilters: 'Suche und Filter zurücksetzen',
    tryAgain: 'Erneut versuchen',
    rowsPerPage: 'Zeilen pro Seite',
    range: '{{from}}–{{to}} von {{count}}',
    previousPage: 'Vorherige Seite',
    nextPage: 'Nächste Seite',
  },
  coaches: {
    title: 'Coaches',
    subtitle:
      'Die Coaches, die Ihre Organisation anbietet. Sie entscheiden, wen Sie ' +
      'fragen und was diese Person von Ihren Messwerten sehen darf.',
    coachingSubtitle: 'Die Menschen, die Sie begleiten, die Anfragen an Sie und wie das Coach-Verzeichnis Sie zeigt.',
    unnamedCoach: 'Coach ohne Namen',
    unnamedMember: 'Mitglied ohne Namen',

    requestPendingChip: 'Anfrage gesendet',
    ask: 'Diesen Coach fragen',
    details: 'Details',
    withdrawRequest: 'Anfrage zurückziehen',
    access: {
      held: 'Sieht {{see}} Ihrer Messwerte und darf {{record}} eintragen.',
      asked: 'Möchte {{see}} Messwerte sehen und {{record}} eintragen.',
    },
    cannotAsk: {
      alreadyMyCoach: 'Dieser Coach sieht Ihre Messwerte bereits.',
      requestPending: 'Ihre Anfrage wartet noch auf eine Antwort.',
      notAccepting: 'Dieser Coach nimmt derzeit niemanden neu auf.',
    },

    askTitle: '{{name}} fragen',
    askExplainer:
      'Wählen Sie, was dieser Coach sehen darf. Sie können das jederzeit unter ' +
      'Ihren Coaches ändern oder beenden.',
    measurement: 'Messwert',
    maySee: 'Darf sehen',
    mayRecord: 'Darf eintragen',
    maySeeAria: 'Darf {{name}} sehen',
    mayRecordAria: 'Darf {{name}} eintragen',
    messageLabel: 'Nachricht (optional)',
    sendRequest: 'Anfrage senden',
    askFailed: 'Die Anfrage konnte nicht gesendet werden.',
    scopesUnavailable: 'Die Messwerte Ihres Programms konnten nicht gelesen werden.',
    noProgrammeYet:
      'Sie folgen noch keinem Programm, und was geteilt werden kann, kommt aus dem Programm.',
    someUnsharable:
      'Noch nicht teilbar: {{names}}. Diesen Messwerten fehlt ein LOINC-Code — bitten Sie einen Administrator, einen Code zuzuordnen.',
    noMeasurementsYet:
      'Ihr Programm nennt noch keine Messwerte, es gibt also nichts zu teilen.',

    waitingForYou: 'Wartet auf Ihre Antwort',
    stillWaiting: 'Wartet noch auf eine Antwort',
    earlierRequests: 'Frühere Anfragen',
    offeredAccess: 'Worum gebeten wurde',
    sharedProgrammes: 'Programme, die Sie teilen',
    askedOn: 'Gefragt am {{when}}',
    answerableUntil: 'Kann beantwortet werden bis {{when}}',
    expiredOn: 'Abgelaufen am {{when}}',
    expired: 'Abgelaufen',
    accept: 'Annehmen',
    decline: 'Ablehnen',
    declineTitle: 'Anfrage ablehnen',
    declineReasonLabel: 'Grund (optional)',
    actionFailed: 'Das hat nicht funktioniert.',
    status: {
      pending: 'Wartet auf Antwort',
      accepted: 'Angenommen',
      declined: 'Abgelehnt',
      withdrawn: 'Zurückgezogen',
      expired: 'Abgelaufen',
    },

    myListing: 'Ihr Coach-Profil',
    myListingExplainer:
      'Nur Sie setzen dieses Profil in die Liste. Das ist unabhängig von Ihrer ' +
      'Freigabe für die Gemeinschaft.',
    listingSaved: 'Coach-Profil gespeichert.',
    saveFailed: 'Das Profil konnte nicht gespeichert werden.',
    headlineLabel: 'Kurzbeschreibung',
    bioLabel: 'Über Sie',
    programmesLabel: 'Programme, die Sie begleiten',
    maxMembersLabel: 'Maximale Anzahl Personen',
    maxMembersHelp_one: 'Sie begleiten derzeit {{count}} Person.',
    maxMembersHelp_other: 'Sie begleiten derzeit {{count}} Personen.',
    acceptingLabel: 'Offen für neue Personen',
    publishLabel: 'In meiner Organisation anbieten',
    publishNeedsBoth:
      'Ein gelistetes Profil braucht eine Kurzbeschreibung und etwas über Sie: ' +
      'danach wählt jemand aus.',

    peopleYouFollow: 'Personen, die Sie begleiten',
    peopleYouFollowExplainer:
      'Was Sie von jemandem sehen dürfen, entscheidet diese Person selbst.',

    directoryUnknown: 'Die Liste konnte nicht gelesen werden',
    directoryUnknownNotice: 'Bitte versuchen Sie es später erneut.',
    onlyYouListedTitle: 'Sie sind der einzige gelistete Coach',
    onlyYouListedNotice:
      'Noch kein anderer Coach Ihrer Organisation hat ein Profil veröffentlicht.',
    noneListedTitle: 'Noch keine Coaches in der Liste',
    noneListedNotice:
      'Sobald ein Coach Ihrer Organisation ein Profil veröffentlicht, erscheint er hier.',
    canAsk: 'Coaches, die Sie fragen können',
    allAlreadyYoursTitle: 'Noch keine weiteren Coaches',
    allAlreadyYoursNotice: 'Die Coaches, von denen Sie schon begleitet werden, stehen oben. Weitere Coaches Ihrer Organisation erscheinen hier, sobald sie ein Profil veröffentlichen.',
    onlyAccepting: 'Nur wer neue Personen aufnimmt',
    search: 'Coach suchen',
    noneAcceptingTitle: 'Derzeit nimmt niemand neue Personen auf',
    noneAcceptingNotice: 'Keiner der gelisteten Coaches ist gerade offen für neue Personen.',
    listingUnknownTitle: 'Ihr Coach-Profil konnte nicht gelesen werden',
    listingUnknown: 'Was Sie hier sehen, kann veraltet sein.',
    noListingTitle: 'Sie haben kein Coach-Profil',
    noListing:
      'Auf diesem Bildschirm bearbeitet ein Coach das Profil, das Mitglieder sehen. Ihr Konto hat keine Coach-Rolle, daher gibt es hier noch nichts zu bearbeiten.',
    grantsUnknownTitle: 'Ihre Coaches konnten nicht gelesen werden',
    grantsUnknown: 'Was Sie hier sehen, kann veraltet sein.',
    noneMatchTitle: 'Kein Coach gefunden',
    noneMatchNotice: 'Nichts passt zu "{{query}}". Versuchen Sie einen Teil eines Namens oder eines Programms.',

    myCoaches: 'Ihre Coaches',
    changeOnCoaches:
      'Welche Messwerte ein Coach sehen darf, ändern Sie auf der Seite Coaches.',
    whatTheyMaySee: 'Was diese Person sehen darf',
    sinceExplainer: 'Sie haben diesen Zugang am {{when}} gegeben. Änderungen gelten sofort.',
    saveAccess: 'Änderungen speichern',
    accessSaved: 'Änderungen gespeichert.',
    accessSaveFailed: 'Die Änderung konnte nicht gespeichert werden.',
    keepOneOrEnd:
      'Behalten Sie mindestens einen Messwert oder beenden Sie stattdessen den Zugang — so wird der Coach informiert.',
    nothingShared: 'Mit diesem Coach ist nichts geteilt.',
    accessEndedOn: 'Dieser Zugang endete am {{when}}.',
    offerUnreadable:
      'Die Messwerte Ihres Programms konnten nicht gelesen werden, daher wird nur aufgeführt, was bereits geteilt ist.',
    endCoaching: 'Zugang beenden',
    endCoachingTitle: 'Zugang beenden',
    endCoachingBody:
      '{{name}} kann Ihre Messwerte danach nicht mehr sehen. Was bereits ' +
      'erfasst ist, bleibt.',
    grantedOn: 'Zugang gegeben am {{when}}',
    endedCoaching: 'Beendete Begleitung',
    endedOn: 'Beendet am {{when}}',
    revokeFailed: 'Der Zugang konnte nicht beendet werden.',

    tabs: {
      coaches: 'Meine Coaches',
      history: 'Verlauf',
      listing: 'Mein Coachprofil',
      requests: 'Anfragen an mich',
      members: 'Menschen, die ich begleite',
    },

    noProgrammeTitle: 'Sie folgen noch keinem Programm',
    noProgrammeNotice: 'Ein Coach begleitet ein Programm. Sobald Sie an einem teilnehmen, erscheinen hier die Coaches, die es begleiten.',
    noHistoryTitle: 'Noch nichts zum Zurückblicken',
    noHistoryNotice: 'Beendete Begleitung und Anfragen, aus denen nichts wurde, bleiben hier stehen.',
    peopleYouCoached: 'Von Ihnen begleitete Menschen',
    noPastMembersTitle: 'Niemand hat aufgehört',
    noPastMembersNotice: 'Alle, die Sie begleiten, sind noch dabei. Beendete Begleitung wird hier festgehalten.',
    noOpenRequestsTitle: 'Keine wartenden Anfragen',
    noOpenRequestsNotice: 'Wenn jemand Sie um Begleitung bittet, erscheint die Anfrage hier.',
    answeredRequests: 'Beantwortete Anfragen',
    noMembersYetTitle: 'Sie begleiten noch niemanden',
    noMembersYetNotice: 'Sobald jemand Ihre Anfrage annimmt, erscheint diese Person hier, mit dem, was Sie sehen dürfen.',
    memberUnreadableTitle: 'Diese Messwerte konnten nicht gelesen werden',
    memberUnreadable: 'Bitte versuchen Sie es in einem Moment erneut.',
    nothingPermittedTitle: 'Nichts anzuzeigen',
    nothingPermittedNotice: 'Die Programme dieser Person nennen keine Messwerte, die mit Ihnen geteilt werden könnten.',
    nothingSharedWithYouTitle: 'Noch nichts freigegeben',
    nothingSharedWithYouNotice: 'Diese Person hat Ihnen noch keine Messwerte freigegeben. Was freigegeben werden könnte, steht unten.',
    notShared: 'Nicht für Sie freigegeben',
    notSharedNotice: 'Diese Person hat diesen Messwert nicht freigegeben, daher wird dazu nichts angezeigt.',
    sourceUnavailable: 'Quelle hat nicht geantwortet',
    sourceIncomplete: 'Teilweise nicht lesbar',
    sourceIncompleteNotice: 'Einige Werte dieser Quelle konnten nicht gelesen werden, daher ist hier nicht alles zu sehen.',
    sourceSilent: 'Die Quelle mit diesen Werten hat nicht geantwortet',
    sourceRefused: 'Quelle für Sie nicht lesbar',
    sourceNotReadForYou: 'Die Quelle mit diesen Werten kann nicht in Ihrem Namen gelesen werden',
    recordedHere: 'Auf dieser Plattform erfasst',
    fromSourceAsOf: 'Von {{source}}, abgerufen {{when}}',
    asOfUnknown: 'zu einem unbekannten Zeitpunkt',
    mixedSources: 'Die Werte stammen aus {{places}} verschiedenen Quellen, daher wird keine Veränderung angezeigt.',
    sourcesDegradedTitle: 'Es können Werte fehlen',
    sourcesDegraded: 'Keine Antwort von {{names}}. Dort gespeicherte Werte können auf diesem Bildschirm fehlen.',
    sourcesRefusedTitle: 'Einige Werte können nicht angezeigt werden',
    sourcesRefused: '{{names}} kann nicht in Ihrem Namen gelesen werden, daher fehlen dort gespeicherte Werte auf diesem Bildschirm. Es geht um den Zugang zwischen dieser Quelle und dieser Plattform, nicht darum, was diese Person für Sie freigegeben hat.',
    sourceNotConnectedChip: 'Nicht verbunden',
    sourceNotConnectedCaption: 'Verbinden Sie Ihr eigenes Konto, um die Werte dieser Quelle zu lesen',
    sourcesNotConnectedTitle: 'Verbinden, um einige Werte zu lesen',
    sourceNotConnected: '{{name}} kann nur mit Ihrem eigenen Konto gelesen werden. Verbinden Sie es einmal, dann können die Werte, die diese Person mit Ihnen geteilt hat, hier angezeigt werden.',
    sourceReconnect: 'Ihre Verbindung zu {{name}} wurde beendet, daher fehlen dort gespeicherte Werte auf diesem Bildschirm. Verbinden Sie erneut, um zu lesen, was diese Person mit Ihnen geteilt hat.',
    connectSource: '{{name}} verbinden',
    reconnectSource: '{{name}} erneut verbinden',
    connectedTitle: 'Mit {{source}} verbunden',
    connectedBody: 'Öffnen Sie diese Person erneut, um die geteilten Werte zu lesen.',
    connectFailedTitle: 'Die Verbindung konnte nicht hergestellt werden',
    connectFailedBody: 'Es wurde nichts geändert. Versuchen Sie es später erneut.',
    notConnectedTitle: 'Nicht mit {{source}} verbunden',
    connectReasons: {
      refused: '{{source}} hat die Anmeldung nicht akzeptiert, daher wurde nichts verbunden.',
      no_code: 'Die Anmeldung bei {{source}} hat nichts zurückgegeben, daher wurde nichts verbunden.',
      no_party_id: 'Ihr Konto bei {{source}} trägt noch keine JLAM-ID und kann Sie dort daher nicht benennen. Fragen Sie, wer die Konten verwaltet.',
      no_person: 'Ihr Konto hier ist keiner Person zugeordnet und kann daher nicht verbunden werden.',
    },
    sourcesStaleTitle: 'Einige Werte könnten veraltet sein',
    sourcesStale: 'Keine Aktualisierung von {{names}} möglich. Was dort seit der letzten Abfrage erfasst wurde, fehlt auf diesem Bildschirm.',
    withheldFromHistory: 'Nicht für Sie freigegeben: {{names}}',
    source: 'Quelle',
    asOf: 'Abgerufen',
    here: 'Diese Plattform',
    lastRecorded: 'Zuletzt erfasst am {{when}}',
    lastRecordedByYou: 'Zuletzt von Ihnen erfasst am {{when}}',
    noReadingYet: 'Noch kein Wert erfasst',
    readOnlyHere: 'Nur ansehen',
    newValue: 'Neuer Wert',
    unit: 'Einheit',
    measuredAt: 'Gemessen am',
    momentInFuture: 'Eine Messung kann nicht in der Zukunft liegen.',
    recordedSome_one: '{{count}} Wert erfasst; der Rest nicht.',
    recordedSome_other: '{{count}} Werte erfasst; der Rest nicht.',
    record: 'Erfassen',
    recorded_one: '{{count}} Wert erfasst.',
    recorded_other: '{{count}} Werte erfasst.',
    recordFailed: 'Der Wert konnte nicht erfasst werden.',
    nothingToRecord: 'Geben Sie zuerst einen Wert ein.',
    valueNotANumber: 'Diese Messung erwartet eine Zahl.',
    requestSent: 'Anfrage an {{name}} gesendet.',
    requestAccepted: 'Sie begleiten jetzt {{name}}.',
    requestDeclined: 'Anfrage von {{name}} abgelehnt.',
    requestWithdrawn: 'Anfrage an {{name}} zurückgezogen.',
    accessEnded: '{{name}} kann Ihre Messwerte nicht mehr sehen.',
    findSomeoneYouCoach: 'Person suchen, die Sie begleiten',
    personColumn: 'Person',
    sinceColumn: 'Seit',
    trendColumn: 'Trend',
    lastActivityColumn: 'Zuletzt erfasst',
    lastActivityNever: 'Noch nichts erfasst',
    lastActivityOn: 'Zuletzt erfasst am {{when}}',
    searchMembers: 'Suche unter den Menschen, die du begleitest',
    noMatchesTitle: 'Niemand passt dazu',
    noMatchesNotice: 'Versuche einen kürzeren Suchbegriff oder leere das Feld.',
    openMember: '{{name}} öffnen',
    caseloadUnknownTitle: 'Die Menschen, die du begleitest, konnten nicht gelesen werden',
    caseloadUnknownNotice: 'Bitte versuche es gleich noch einmal.',
    jumpToAnother: 'Zu einer anderen Person',
    memberNotInCaseloadTitle: 'Keine Person, die du begleitest',
    memberNotInCaseloadNotice: 'Diese Person steht nicht auf deiner Liste. Die Begleitung kann beendet sein, oder der Link ist alt.',
    trendNothing: 'Noch nichts geteilt',
    trendInRange_one: '{{count}} im Zielbereich',
    trendInRange_other: '{{count}} im Zielbereich',
    trendToward_one: '{{count}} bewegt sich zum Ziel',
    trendToward_other: '{{count}} bewegen sich zum Ziel',
    trendAway_one: '{{count}} bewegt sich vom Ziel weg',
    trendAway_other: '{{count}} bewegen sich vom Ziel weg',
    trendTracked_one: '{{count}} Messwert verfolgt',
    trendTracked_other: '{{count}} Messwerte verfolgt',
    coachingSince: 'Begleitung seit {{when}}',
    viewTrends: 'Trends',
    viewHistory: 'Historie',
    recordedAt: 'Erfasst',
    value: 'Wert',
    recordedBy: 'Erfasst von',
    you: 'Sie',
    noReadingsTitle: 'Noch nichts erfasst',
    noReadingsNotice: 'Für diese Person erfasste Werte erscheinen hier, die neuesten zuerst.',
  },
  manageRoles: {
    noTenantNotice: 'Rollen gehören zu einer Organisation, und dieses Konto gehört zu keiner.',
    noTenantTitle: 'Keine Organisation, deren Rollen gezeigt werden könnten',
  },
  look: {
    title: 'Symbol und Farben',
    symbol: {
      title: 'Symbol',
      description: 'Wird jedem Mitglied in der Navigationsleiste neben dem Namen des Tenants angezeigt. Es gehört zur Organisation, daher zeigen alle ihre Tenants dasselbe Symbol.',
      preview: 'So steht das Symbol in der Navigationsleiste',
      none: 'Noch kein Symbol. Mitglieder sehen nur den Namen des Tenants.',
      accepted: 'PNG oder WebP, höchstens 512 KB und mindestens 64 × 64 Pixel.',
      choose: 'Bild auswählen',
      save: 'Symbol speichern',
      saved: 'Symbol gespeichert.',
      remove: 'Symbol entfernen',
      removed: 'Symbol entfernt.',
      refused: 'Diese Datei kann nicht verwendet werden. Wählen Sie ein PNG- oder WebP-Bild mit höchstens 512 KB und mindestens 64 × 64 Pixeln.',
      error: 'Das Symbol konnte nicht gespeichert werden. Versuchen Sie es erneut.',
    },
    profiles: {
      title: 'Farbprofile',
      description: 'Mitglieder sehen das Standardprofil, bis sie selbst eines wählen. Die Standardprofile von MLP werden immer neben Ihren eigenen angeboten.',
      standard: 'Standardprofil von MLP',
      own: 'Profil dieses Tenants',
      default: 'Standard',
      makeDefault: 'Als Standard festlegen',
      defaultSaved: '{{name}} ist jetzt das Standardprofil.',
      edit: 'Farben bearbeiten',
      history: 'Verlauf',
      add: 'Profil hinzufügen',
      newName: 'Name des Profils',
      create: 'Profil speichern',
      added: '{{name}} wurde als Version 1 hinzugefügt.',
      duplicateName: 'Dieser Tenant hat bereits ein Profil mit diesem Namen. Wählen Sie einen anderen Namen.',
      loadError: 'Die Farbprofile konnten nicht geladen werden. Laden Sie die Seite neu, um es erneut zu versuchen.',
      saveError: 'Die Änderung konnte nicht gespeichert werden. Versuchen Sie es erneut.',
    },
    editor: {
      title: 'Farben von {{name}}',
      newTitle: 'Neues Farbprofil',
      hexLabel: 'Hexwert von {{role}}',
      variants: 'Hellere, Haupt- und dunklere Variante, mit der Textfarbe auf der Hauptvariante',
      textSample: 'Aa',
      contrastIntro: 'Mit diesen Farben wäre Text schwer lesbar. Ändern Sie die unten genannte Farbe:',
      contrastFailure: '{{role}}, {{pairing}}: {{ratio}}:1, wo mindestens {{required}}:1 nötig ist',
      pairing: {
        textOnColour: 'Text auf dieser Farbe',
        linkOnPaper: 'als Linktext auf Weiß',
        linkOnPage: 'als Linktext auf dem Seitenhintergrund',
      },
      save: 'Als neue Version speichern',
      saved: 'Als Version {{version}} gespeichert.',
      reset: 'Auf Meridian zurücksetzen',
      close: 'Schließen',
    },
    history: {
      title: 'Verlauf von {{name}}',
      version: 'Version {{version}}',
      savedBy: '{{when}}, von {{who}}',
      savedAt: '{{when}}',
      current: 'In Verwendung',
      rollBack: 'Auf diese Version zurücksetzen',
      rolledBack: 'Zurückgesetzt. Als Version {{version}} gespeichert.',
      loadError: 'Der Verlauf konnte nicht geladen werden.',
      rollBackError: 'Das Zurücksetzen konnte nicht gespeichert werden. Versuchen Sie es erneut.',
    },
    preview: {
      title: 'Vorschau',
      navigationCurrent: 'Dashboard',
      navigationOther: 'Messungen',
      button: 'Speichern',
      secondButton: 'Hinzufügen',
      link: 'Ein Link',
      chart: 'Eine Messung über eine Woche, mit ihrem Zielbereich',
    },
    roles: {
      primary: {
        name: 'Hauptfarbe',
        hint: 'Navigation, Schaltflächen, Links und Fokus',
      },
      secondary: {
        name: 'Zweite Farbe',
        hint: 'Zweite Schaltflächen und Hervorhebungen',
      },
      success: {
        name: 'Im Bereich',
        hint: 'Ein Wert, wo er sein soll, und was gelungen ist',
      },
      warning: {
        name: 'Außerhalb des Bereichs',
        hint: 'Ein Wert, der vom Ziel abweicht',
      },
      error: {
        name: 'Fehler',
        hint: 'Fehlermeldungen und was jetzt Aufmerksamkeit braucht',
      },
      info: {
        name: 'Information',
        hint: 'Neutrale Hinweise',
      },
    },
    standard: {
      meridian: 'Meridian',
      lagune: 'Lagune',
      classic: 'Klassisch',
    },
    choice: {
      title: 'Farbprofil',
      description: 'So sieht die App für Sie aus. Ihre Wahl gilt, sobald Sie Ihr Profil speichern, und begleitet Sie auf andere Geräte.',
      followTenant: 'Standard von {{tenant}} ({{name}})',
      followMeridian: 'Standard von MLP (Meridian)',
      loadError: 'Die Farbprofile konnten nicht geladen werden.',
    },
  },
  valueDetail: {
    title: 'Woher dieser Wert kommt',
    traceTitle: 'Spur dieses Werts',
    loading: 'Die Herkunft dieses Werts wird gelesen',
    missing: 'Es gibt keinen Wert mit dieser Nummer.',
    failed: 'Die Herkunft dieses Werts konnte nicht gelesen werden.',
    retry: 'Erneut versuchen',
    value: 'Wert',
    time: 'Zeit',
    notKnown: 'Mehr ist über diesen Wert nicht bekannt.',
    recorded: 'Wie erfasst',
    code: 'Code',
    codeSystem: 'Codesystem: {{system}}',
    source: 'Quelle',
    sources: {
      manualInput: 'Von dir eingegeben',
      deviceSync: 'Aus einer verbundenen Quelle',
      uploaded: 'Aus einem Dokument',
      coachingSession: 'Von einem Coach',
    },
    shownAs: 'Angezeigt als',
    converted: 'Wie umgerechnet wurde',
    noConversion: 'Keine Umrechnung: wie erfasst angezeigt.',
    conversion: {
      algebra: '1 {{from}} = {{factor}} {{to}}, bestätigt am {{date}}.',
      molarMass: '1 {{from}} = {{factor}} {{to}}, über die Molmasse von {{analyte}} ({{mass}} g/mol, Quelle: {{source}}), bestätigt am {{date}}.',
    },
    reference: 'Referenz',
    changedSince: 'Seitdem geändert',
    notChanged: 'Der Code hat sich seitdem nicht geändert.',
    laterRelease: 'Eine spätere Version hat diesen Code geändert, nachdem der Wert erfasst wurde.',
    change: '{{field}}: {{from}} → {{to}} ({{date}})',
    showFullOrigin: 'Vollständige Herkunft anzeigen',
    close: 'Schließen',
    graphLabel: 'Messwerte. Mit den Pfeiltasten wechselst du zwischen ihnen.',
    graphOpenHint: 'Drücke Enter, um ihn zu öffnen.',
  },
  groupingLevels: {
    label: 'Wie weit Werte zählen',
    loading: 'Die Ebenen werden gelesen',
    loadFailed: 'Die Ebenen konnten nicht gelesen werden. Die gespeicherte Ebene bleibt unverändert.',
    THIS_CODE: {
      name: 'Nur dieser Code',
      help: 'Nur Werte, die unter genau diesem Code erfasst wurden, zählen.',
    },
    ANY_METHOD: {
      name: 'Dasselbe, egal mit welcher Methode',
      help: 'Werte derselben Sache zählen, ob zu Hause oder in einer Praxis gemessen.',
    },
  },
};

export default { translation };
